module.exports = __webpack_public_path__ + "img/pc3.f98182de.png";